<template>
  <v-dialog
    v-model="dialog"
    :max-width="stepsWidth[step] || 800"
    content-class="rounded-lg"
    scrollable
  >
    <v-card class="rounded-lg">
      <v-card-title class="d-block pa-0">
        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-header>
            <v-stepper-step
              step="1"
              :complete="step > 1"
              title="Identificação do pagamento"
            ></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              step="2"
              :complete="step > 2"
              title="Detalhes da compra"
            ></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              step="3"
              :complete="step > 3"
              title="Usuário"
            ></v-stepper-step>
            <!-- <v-divider></v-divider>
            <v-stepper-step
              step="4"
              :complete="step > 4"
              title="Outras compras"
            ></v-stepper-step> -->
          </v-stepper-header>
        </v-stepper>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-content step="1">
            <chargeback-payment-localizer
              v-if="step === 1"
              @close="close"
              @payment="localizePayment"
            />
          </v-stepper-content>
          <v-stepper-content step="2">
            <chargeback-payment-actions
              @close="close"
              :payment="payment"
              @reported="reported"
            />
          </v-stepper-content>
          <v-stepper-content step="3">
            <chargeback-user-info
              v-if="step === 3"
              @close="close"
              :payment="payment"
              :refund="refund"
              :antifraud="antifraud"
            />
          </v-stepper-content>
          <!-- <v-stepper-content step="4">
            <chargeback-payment-list
              v-if="step === 4"
              @close="close"
              :payment="payment"
              :refund="refund"
              :antifraud="antifraud"
            />
          </v-stepper-content> -->
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ChargebackPaymentLocalizer from "./modules/ChargebackPaymentLocalizer.vue";
import ChargebackPaymentActions from "./modules/ChargebackPaymentActions.vue";
import ChargebackUserInfo from "./modules/ChargebackUserInfo.vue";

export default {
  name: "ChargebackReportModal",
  components: {
    ChargebackPaymentLocalizer,
    ChargebackPaymentActions,
    ChargebackUserInfo,
  },
  data() {
    return {
      dialog: false,
      step: 1,
      stepsWidth: {
        1: "500",
        2: "500",
      },
      payment: null,
      refund: null,
      antifraud: null,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.step = 1;
    },
    close() {
      this.dialog = false;
    },
    localizePayment(payment) {
      this.payment = payment;
      this.step = 2;
    },
    reported(response) {
      this.step = 3;
      this.refund = response.refund;
      this.antifraud = response.antifraud;
    },
  },
  mounted() {
    this.$parent.$on("report-chargeback-modal", this.open);
  },
};
</script>
